import { UploadImage } from './UploadImage'
import { withUploadImage } from './withUploadImage'

const ConnectedUploadImage = withUploadImage(UploadImage)

export { ConnectedUploadImage as UploadImage }
